import React, { useEffect, useState, type JSX } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';
import Accordion from '@mui/material/Accordion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SPACING_BETWEEN_FORM_FIELDS } from '../../../components/common/spacings';
import { Mandant } from '../../../types';
import { EmailTextField } from '../../../components/common/EmailTextField';

type HisConfigProps = {
  readonly isLoading: boolean;
  readonly mandant: Mandant;
  readonly speichereMandant: (mandant: Partial<Mandant>) => void;
};

export function HisConfig({ isLoading, mandant, speichereMandant }: HisConfigProps): JSX.Element {
  const [error, setError] = useState<boolean>(false);
  const [hisEmail, setHisEmail] = useState<string>(mandant.hisEmail ?? '');

  useEffect(() => {
    if (mandant.id && mandant.hisEmail) {
      setHisEmail(mandant.hisEmail);
    }
  }, [mandant]);

  const checkEmail = (email: string): void => {
    const check = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ).test(email);
    setError(!check);
  };

  return (
    <Accordion data-testid="hisAccordion">
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
        <Typography variant="h6" gutterBottom>
          HIS-Kontakt
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={SPACING_BETWEEN_FORM_FIELDS}>
          <Grid size={6}>
            <EmailTextField
              fullWidth
              label="HIS Kontakt E-Mail"
              defaultValue={hisEmail ?? ''}
              data-testid="email"
              onChange={(event) => {
                checkEmail(event.target.value);
                setHisEmail(event.target.value);
              }}
              error={error}
            />
          </Grid>
          <Grid>
            <Button
              onClick={() =>
                speichereMandant({
                  hisEmail: hisEmail
                })
              }
              color="primary"
              variant="contained"
              disabled={isLoading || error}
              data-testid="submit"
            >
              Speichern
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
